// extracted by mini-css-extract-plugin
module.exports = {"gradient_border":"VerticalInfoContent_gradient_border__ijRWQ"};